<div class="languages-empty">
  <div class="languages-empty__content">
    <fa-icon class="languages-empty__icon" [icon]="faGlobe"></fa-icon>

    <span class="fs__lg fw__600">No languages added yet</span>

    <span class="languages-empty__description fs__sm">{{ message() }}</span>

    <div class="languages-empty__actions">
      <eiq-button
        [icon]="faPlus"
        [text]="'Add New Language'"
        [color]="'primary'"
        [disabled]="disableAddLanguage()"
        [testId]="'languages-empty-add-language'"
        (clicked)="addLanguage.emit()"
      >
      </eiq-button>

      @if (showLanguageSettingsButton()) {
        <eiq-button
          [icon]="faGear"
          [text]="'Language Settings'"
          [color]="'light'"
          [style]="'stroked'"
          [testId]="'languages-empty-settings'"
          (clicked)="languageSettings.emit()"
        >
        </eiq-button>
      }
    </div>
  </div>

  <div class="languages-empty__info">
    <fa-icon [icon]="faLanguage"></fa-icon>
    <div class="languages-empty__info-content">
      <span class="fs__sm fw__600">How translations work</span>
      <span class="fs__sm">
        Add target languages, then translate each survey string manually or import translations from an Excel file. You can also export missing translations for
        external translators.
      </span>
    </div>
  </div>
</div>
